import ModalActionTypes from './types';
import { removeByKey } from './utils';

const initialState = {
  currentModals: null,
};

const modalReducer = (state = initialState, action) => {
  switch (action.type) {
    case ModalActionTypes.SHOW_MODAL:
      return {
        ...state,
        currentModals: {
          ...state.currentModals,
          [action.payload.modalType]: action.payload.modalProps,
        },
      };
    case ModalActionTypes.HIDE_MODAL:
      return {
        ...state,
        currentModals: removeByKey(state.currentModals, action.payload),
      };
    default:
      return state;
  }
};

export default modalReducer;
